import React, { useState, useRef, useEffect, useCallback } from "react";
import "react-map-gl-geocoder/dist/mapbox-gl-geocoder.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "../SearchExplorer/SearchExplorer.css";
import "react-map-gl-geocoder/dist/mapbox-gl-geocoder.css";
import { Col, Container, Row } from "reactstrap";
import { handlingCatchError } from "../../../Utils/ErrorHandling";

import WebMercatorViewport from "viewport-mercator-project";
import { Link, useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { Config } from "../../../Utils/Config";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { PreviewMarketMap } from "./PreviewMarketMap";
import {Helmet} from "react-helmet";
import ConstantData from "../../../Utils/Constant";
import { checkImpersonation } from "../../../helpers/dataHelper";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";

var circles = {};
var extp = [];
let summary = [];
let lat, lng, rvParksCount;

export const PreviewMarket = () => {
  const [viewport, setViewPort] = useState({
    width: "100%",
    height: "100vh",
    longitude: -109.4293977,
    latitude: 47.0721469,
    zoom: 2.51,
    cursor: "pointer",
  });
  const [parks, setParks] = useState({});
  const [geoCoderValues, setgeoCodingData] = useState({});
  const [profile, setProfile] = useState({
   
    showProfile: false,
    address: null,
    city: null,
    state: null,
    zipCode: null,
    latitude: null,
    longitude: null,
    
  });
  const [selectedPins, setSelectedPins] = useState({
    latitude: null,
    longitude: null,
    name: null,
    address: null,
    address1: null,
    city: null,
    state: null,
    country: null,
    zip: null,
    profileId: null,
  });
  const [parksData, setParksData] = useState({});
  const [loading] = useState(false);
  const [marketSummary, setMarketSummary] = useState({});
  const [radius, setRadius] = useState(50);
  const [showCircle, setShowCircle] = useState(false);
  const [address] = useState("");
  const [profileAdd, setProfileAdd] = useState("");
  const [profileAddress, setProfileAddress] = useState("");
  const [marketCenter, setMarketCenter] = useState({ latitude: null, longitude: null });
  const [resetValues, resetMarketView] = useState(0);
  const [summary_, setSummary] = useState({
    showSummary: false,
    address: null,
    city: null,
    state: null,
    zipCode: null,
    latitude: null,
    longitude: null,
    radius: null,
  });
  const applyToArray = (func, array) => func.apply(Math, array);
  var el = document.getElementsByClassName("mapboxgl-ctrl-geocoder--button");
  const mapRef = useRef();
  const geocoderContainerRef = useRef();

  const navigate = useNavigate();
  //layer created for rv pinponts
  const layerStyle = {
    id: "point",
    type: "circle",
    paint: {
      "circle-radius": 4,
      "circle-color": ["get", "iskoa"],
    },
  };

 
  useEffect(() => {
    if (selectedPins.latitude !== null && selectedPins.longitude !== null) {
      circles = {};
      getCircle(selectedPins.latitude, selectedPins.longitude, radius, "2");
      getSummary(selectedPins.latitude,selectedPins.longitude, radius);
    }
  }, [resetValues]);
  const purchaseMartket = () => {
    if(localStorage.getItem('impersonated') === 'true') {
      checkImpersonation();
    }else{
    clearSearchResult();
    // setLoading(true);
      let inputData={
         "Latitude": lat,
        "Longitude": lng,
        "Radius": radius,
        "RVParksCount": rvParksCount,
        "DownloadFileName": null,
        "Remarks": null,
        "Address": address
        }
         apiCommonTrigger("post",`${Config.API_URL}/subscription/checkoutmarket`,inputData) 
      .then((res) => {
        if (res.status === 200) {
          // setLoading(false);
          navigate(`/buy-market-report?sessionid=${res.data.accesskey}`);
        }
        else{
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
    }
  }

    //market center actions
    const callMarketCenter = useCallback((lat, lng) => {
   
      setSummary({
        ...summary_,
        showSummary: true,
        radius: radius,
      });
      setShowCircle(true);
      resetMarketView(Math.random());
      setMarketCenter({...marketCenter, latitude: lat, longitude: lng});
      // childRef.current.callOnSubmit(radius, "1");
    }, []);
  
  const setSelectedPin = (data, selection) => {
    let lat = parseFloat(data.latitude);
    let lng = parseFloat(data.longitude);
    // setPopUp(true);
    setSelectedPins({
      ...selectedPins,
      latitude: lat,
      longitude: lng,
      name: data.name,
      address: data.Street_Address1 ? data.Street_Address1 : data.address,
      address1: data.Street_Address2 ? data.Street_Address2 : data.address1,
      city: data.city,
      state: data.state,
      country: data.country,
      profileId: data.profileId,
      zip: data.zip,
    });
  };
  const getSummary = (lat, lng, radius) => {
    clearSearchResult();
    // setLoading(true);
    let inputData={
        lat: lat,
        longi: lng,
        radius: radius,
        }
         apiCommonTrigger("post",`${Config.API_URL}/search/demo`,inputData) 
      .then((res) => {
        if (res.status === 200) {
          clearSearchResult();
          // setLoading(false);
          setParksData({ ...parksData, parksData: res.data.rvParks });
          setMarketSummary({
            ...marketSummary,
            marketSummary: res.data.summary,
          });
          rvParksCount = res.data.summary.rvparksinmarket;
        }else{
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
  };

  const handleGeocoderViewportChange = useCallback(
    (newViewport) => {
      const geocoderDefaultOverrides = { transitionDuration: 300 };

      return setViewPort({
        ...newViewport,
        ...geocoderDefaultOverrides,
      });
    },
    [setViewPort]
  );

  //clear search box results
  const clearSearchResult = () => {
    if (el && el.length !== undefined && el.length > 0) {
      el[0].click();
    }
  };
  
  //calculate bounding box value for circle default adjustment
  const getBoundingValues = (points) => {
    if (points) {
      const pointsLong = points.geometry.coordinates.map((point) => point[0]);
      const pointsLat = points.geometry.coordinates.map((point) => point[1]);
      const cornersLongLat = [
        [applyToArray(Math.min, pointsLong), applyToArray(Math.min, pointsLat)],
        [applyToArray(Math.max, pointsLong), applyToArray(Math.max, pointsLat)],
      ];
      const viewport = new WebMercatorViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      }).fitBounds(cornersLongLat, {
        padding: { top: 100, bottom: 100, left: 100, right: 100 },
      });
      const { longitude, latitude, zoom } = viewport;
      setViewPort({
        ...viewport,
        latitude: latitude,
        longitude: longitude,
        zoom: zoom,
      });
    }
  };
  const getCircle = (lats, lngs, radi, sel) => {

    circles = {};
    let radiusCal = sel === "2" ? radi : radius;
    let lat = lats;
    let lng = lngs;
    let dir = 1;
    var d2r = Math.PI / 180;
    var r2d = 180 / Math.PI;
    var earthsradius = 3963;
    var points = 64;
    // find the raidus in lat/lon
    var rlat = (radiusCal / earthsradius) * r2d;
    var rlng = rlat / Math.cos(lat * d2r);

    extp = [];
    if (dir === 1) {
      var start = 0;
      var end = points + 1;
    } else {
      var start = points + 1;
      var end = 0;
    }
    for (var i = start; dir === 1 ? i < end : i > end; i = i + dir) {
      var theta = Math.PI * (i / (points / 2));
      let ey = lng + rlng * Math.cos(theta);
      let ex = lat + rlat * Math.sin(theta);
      extp.push([ey, ex]);
    }
    circles = {
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: extp,
      },
    };
    setShowCircle(true);
    getBoundingValues(circles);
  };

  //change radius based on slider value
  const handleOnChangeRadius = (e, selection) => {

    let centerRadius = parseInt(e.target.value);
    setRadius(centerRadius);
    if (lat !== undefined && lng !== undefined) {
      getSummary(lat, lng, centerRadius);
    }
    setViewPort({ ...viewport, zoom: 7 });
    if (showCircle) {
    getCircle(lat, lng, centerRadius, "2");
    }
  };
  //price conversion
  const priceConversion = (tot) => {
    if (tot === null || tot === undefined)
      return '-';

    if (tot !== "") {
      let checkDigit = tot.toString().split(".");
      let ret = "";
      let i = 0;
      if (tot.toString().indexOf(".") == -1) {
        tot = tot;
      } else {
        if (checkDigit == "00") {
          tot = checkDigit.trim();
        } else {
          if (checkDigit.length === 2) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              if (i >= checkDigit[1].length) ret += "0";
              else ret += checkDigit[1][i];
            }
          } else if (checkDigit.length === 1) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              ret += "0";
            }
          }
          ret = ret.toString();
          tot = ret;
        }
      }
    }
    return tot.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  //get parks summary details
  const getSummaryDetails = () => {
    summary = [];
    let summaryDetails = marketSummary.marketSummary;
    const excludedKeys = new Set([
      "rvparkids",
      "caucasian",
      "black",
      "hispanic",
      "others",
      "avgmaleinmarket",
      "avgfemaleinmarket",
      "asianpacific",
      "potentialcampers" , 
      "percentageofhousehold",
      "avgfuelcost"
    ]);
    
    for (let i = 0; i < Object.keys(summaryDetails).length; i++) {
      const key = Object.keys(summaryDetails)[i].toLowerCase(); // Convert key to lowercase
      const value = Object.values(summaryDetails)[i];
      
      if (value !== null && value !== undefined && value !== "" && value !== 0 && !excludedKeys.has(key)) {
        const headerMap = {
          rvparksinmarket: "RV Parks in market",
          totalrvparksites: "Total Camping spots",
          avgpricepernight: "Average price per night",
          countofhousehold: "Households",
          marketscore: "Market Score",
          demandscore: "Demand Score",
          avgsizeofpark: "Average Size Of Park",
          rvownershipinmarket: "RV Ownership in market",
          population: "Population",
          incomepercapita: "Income per capita",
          avgfuelcost: "Average Fuel Cost",
          avgage: "Average Age",
          fivetotwentyfour: "Population age from 5-24",
          twentyfivetofortyfour: "Population age from 25-44",
          fortyfivetofiftyfour: "Population age from 45-54",
          fiftyfivetoseventyfour: "Population age from 55-74",
          seventyfiveandabove: "Population age of 75 And Above"
        };

        // Get the key and convert it to lowercase
        const key = Object.keys(summaryDetails)[i].toLowerCase();

        // Use the headerMap to get the table header or default to the key if not found
        let tableHeader = headerMap[key] || key;


        let formatValue = priceConversion(Object.values(summaryDetails)[i]);

        let headerValue =
          (Object.keys(summaryDetails)[i] === "avgfuelcost" ||
            Object.keys(summaryDetails)[i] === "avgpricepernight" ||
            Object.keys(summaryDetails)[i] === "incomepercapita")
            && formatValue !== '-' ? Config.Currency + formatValue
            : Object.keys(summaryDetails)[i] === "avgsizeofpark" && formatValue !== '-'
              ? formatValue + " Acres"
              : (Object.keys(summaryDetails)[i] === "percentageofhousehold" ||
                Object.keys(summaryDetails)[i] === "avgmaleinmarket" ||
                Object.keys(summaryDetails)[i] === "avgfemaleinmarket")
                && formatValue !== '-' ? formatValue + "%"
                : formatValue;

        summary.push(
          <TableRow key={Object.keys}>
            <TableCell>{tableHeader}</TableCell>
            <td>{headerValue}</td>
          </TableRow>
        );
      }
    }
    return summary;
  };

  const getParksData = () => {    
    const newParksData = [];
    let preview=true;
    apiCommonTrigger("get",Config.API_URL+"/maps/pois/demo/",[preview])
        .then((res) => {
            if (res.status === 200) {
              for(let feature of res.data.features){
                newParksData.push(feature.data); 
              }
              setParks(newParksData);
            }
            else{
              handlingCatchError(res, navigate);
            }
        })
        .catch(err => {
          handlingCatchError(err, navigate);
        })
  }
  
  useEffect(() => { 
    getParksData();
    document.documentElement.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Helmet>
          <title>{'RV Parks & Campgrounds Market Analysis Report Preview | RVParkIQ'}</title>
          <meta name="description" content="Find investment opportunities, get ownership information, analyze properties & run market reports. RVParkIQ is the only market intelligence platform for RV Park & Campground investors" />
      </Helmet>
      <div
        className="subscription-wrapper preview-market-before"
        style={{ position: "relative" }}
      >
        <Container fluid>
          <Row>
            <Col
              className="part-right"
            >
              <Container>
                <Row>
                  <Col className="free-subscription" xs={12}>
                    <h3>Market Reports</h3>
                    <h5 className="text-center pb-3" style={{fontSize: '18px'}}>Preview any market before evaluating it further</h5>
                    <p>Search and analyze any market deeper with a PDF report from Market Explorer.  Also included with each market report is 30-day access to the market within the Market Explorer platform, offering additional data for further analysis. Each market report includes data on: </p>
                    
                  </Col>
                  <Col xs={6}>
                    <h5>RV Park Profile</h5>
                    <ul>
                      <li>Property Address</li>
                      <li>Property Details</li>
                      <li>Amenities and Features</li>
                      <li>Ownership, Debt & Transaction History</li>
                      <li>Seasonality</li>
                    </ul>
                  </Col>
                  <Col xs={6}>
                    <h5>Population Profile</h5>
                    <ul>
                      <li>Total RV Parks in the market</li>
                      <li>Average price per night</li>
                      <li>Average size of park</li>
                      <li>Population</li>
                      <li>Population Density</li>
                      <li>Region Type</li>
                      <li>Income per Capita</li>
                    </ul>
                  </Col>
                  <Col xs={12}>
                  <h5>Market Dynamics Score</h5>
                    <ul>
                      <li>Market Demand Score</li>
                      <li>Market Supply Factors</li>
                      <li> ... and more!</li>
                    </ul>
                    <Link to={'../sample-pdf/sample_market_report.pdf'} target={'_blank'} className="border-btn mb-3">View Sample Report</Link>
                  </Col>
                </Row>
              </Container>
            </Col>
           
            <Col className="part-left p-0">
          
              {loading ? (
                <div className="loader-wrap">
                  <div className="loading"></div>
                </div>
               ) : null}              
                <div className="preview-market">
                 { showCircle ? <div className="market-distance p-0">
                    <h5>Market Distance</h5>
                    <div className="slider-radius">
                      <label className="radius-value">{radius} Miles</label>
                      <label
                        className="label-values"
                        style={{ marginRight: "3px" }}
                      >
                        10
                      </label>
                      <input
                        name="radius"
                        type="range"
                        min={10}
                        max={ConstantData.radiusMaxCount}
                        value={radius}
                        onChange={(e) => handleOnChangeRadius(e, "1")}
                        step={1}
                      />{" "}
                      <label className="label-values">{ConstantData.radiusMaxCount}</label>
                    </div>
                </div> : ""}
               
                  <Row className={Object.keys(marketSummary).length == 0 ? "m-0 map-height" :"m-0"}> 
                      <Col md={12} className="preview-map p-0">
                      <PreviewMarketMap/>
                    </Col>
                  </Row>
                  {marketSummary &&
                  marketSummary.marketSummary &&
                  marketSummary.marketSummary.length !== 0 ? (
                    <div className="add-market-wizard">
                     <TableContainer className="table-design">
                        <Table
                          sx={{ minWidth: 650 }}
                          aria-label="simple table"
                          stickyHeader
                        >
                          <TableBody>
                            {marketSummary &&
                              marketSummary.marketSummary &&
                              getSummaryDetails()}
                            {marketSummary &&
                            marketSummary.marketSummary &&
                            marketSummary.marketSummary.length === 0 ? (
                              <TableRow>
                                <TableCell
                                  style={{ textAlign: "center" }}
                                  className="store-no-data"
                                >
                                  No Data Available
                                </TableCell>
                              </TableRow>
                            ) : (
                              ""
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      {marketSummary && marketSummary.marketSummary ? (
                        <button
                          className="use-market"
                          onClick={() => purchaseMartket()}
                        >
                          <ShoppingCartIcon /> Confirm and Buy Market
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )} 
                </div>
            </Col>
          </Row>
        </Container>
      </div>

    </div>
  );
};
